import React from 'react';

const HintsAndTips = () => (
  <div id="hints">
    <div className="container">
      <h4>How do I apply for a position I have seen advertised?</h4>
      <p>
        Click on the Apply Now button at the bottom of the job advertisement and this will take you
        to an online application form. You can then read over the detailed job advertisement and if
        you still feel like you are well suited to the job, answer the questions which follow. Once
        you are satisfied with your answers, click the Apply button and your application will be
        sent directly to the employer for their consideration.
      </p>
      <h4>
        Why do I have to answer all these questions, why can’t I just send through my CV/resume?
      </h4>
      <p>
        The questions on the online application form have been specifically tailored so that the
        Employer is able to get the exact information they require to move forward with your
        application. This not only enables the Employer to more efficiently assess your suitability
        for a role but also gives you an insight into the sorts of qualifications and skills you
        will need to perform the job and therefore decide whether you are a good fit for the role.
        Having read your answers to the online application form the Employer may then contact you
        and ask you to supply a copy of your CV/resume.
      </p>
      <h4>How long should my answers to the questions on the online application form be?</h4>
      <p>
        There is not a specific word limit for your answers as this is dependent on your skills,
        experience and qualifications. Try to answer the questions succinctly but with enough detail
        to ‘sell’ yourself. This is really down to the individual though and you may wish to spend
        less or more time.
      </p>
      <h4>Should I attach my CV/resume?</h4>
      <p>
        In most cases you will not need to attach a CV/resume as your answers to the questions on
        the application form will give the Employer enough information to decide whether they wish
        to move forward with your application. If there is an option to attach your resume, it will
        say so after the job description and before you start filling out your personal details.
      </p>
      <h4>How will I know if my application has been received?</h4>
      <p>
        You should automatically receive a confirmation to your designated email address once you
        have submitted your application. If you have not received this within five minutes of
        submitting your application, please contact Employment Office on 1300 366 573.
      </p>
      <h4>Who will assess my application?</h4>
      <p>
        Once you submit your application it is sent directly to the Employer who will then review
        your application and contact you directly if they wish to move forward.
      </p>
      <h4>When should I expect to hear back regarding my application?</h4>
      <p>
        You can expect to hear back within 24 hours to 30 days of submitting your application
        (depending on the individual Employer). You will either be contacted directly by the
        employer or Employment Office as to the success of your application. Employment Office will
        always endeavour to get back to everyone who applies through our system, whether or not they
        have been successful in gaining the position. Feel free to contact Employment Office on 1300
        366 573 if you ever want to discuss or follow up on your application.
      </p>
    </div>
  </div>
);

export default HintsAndTips;
